import axios from "axios";
import {
  addTenantHeaderInterceptor,
  idTokenInterceptor,
  successHandler,
  errorHandler,
} from "./interceptors";

const athenaClient = axios.create();

// CAREFUL: Interceptors are applied in reverse order! https://github.com/axios/axios/issues/1663
athenaClient.interceptors.request.use(addTenantHeaderInterceptor);
athenaClient.interceptors.request.use(idTokenInterceptor);
athenaClient.interceptors.response.use(successHandler, errorHandler);

export const apolloClient = axios.create();

// CAREFUL: Interceptors are applied in reverse order! https://github.com/axios/axios/issues/1663
apolloClient.interceptors.request.use(addTenantHeaderInterceptor);
apolloClient.interceptors.request.use(idTokenInterceptor);

export const dolosClient = axios.create();

// CAREFUL: Interceptors are applied in reverse order! https://github.com/axios/axios/issues/1663
dolosClient.interceptors.request.use(idTokenInterceptor);

export default athenaClient;
